import { useCallback, useMemo } from "react";
import { useTypedSelector } from "../../../../../../store/reducers/use-typed-selector";
import className from 'classnames';
import ModalComponent from "../../../../../general-ui/modal/modal";
import { useDispatch } from "react-redux";
import { toggleEventPreviewMode } from "../../../../../../store/actions/admin/create-event";
import LiveEventDocumentHead from "../../../../../live-event/live-event-document-head";
import MarketingRegisteredAgenda from "../../../../../live-event/marketing-page/marketing-registered-agenda/marketing-registered-agenda";
import { EPreviewTypes } from "../../../../../../types/working-model";
import PreviewEventChatMain from "../../../../../live-event/event-chat/preview-event-chat-main";

interface AgendaPreviewProps {
	open: boolean;
}

const AgendaPreviewModal: React.FC<AgendaPreviewProps> = ({ open }) => {
	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const editorSize = useTypedSelector(state => state.CreateEventReducer.editorSize);
	const previewMode = useTypedSelector(state => state.CreateEventReducer.previewMode);

	const dispatch = useDispatch();


	const modalBody = useMemo(() => {
		return workingEvent && (
			<div className={className("event-preview-wrapper live-event-container", editorSize)}>
				<LiveEventDocumentHead eventBundle={workingEvent} />
				<MarketingRegisteredAgenda />
				<PreviewEventChatMain />
			</div>
		);
	}, [workingEvent, editorSize]);

	const closeModal = useCallback(() => {
		dispatch(toggleEventPreviewMode(null));
	}, [dispatch]);

	return (
		<div
			className="preview-modal"
			style={previewMode !== EPreviewTypes.Agenda ? { display: 'none' } : {}}
		>
			<ModalComponent
				open={open}
				onRequestClose={closeModal}
				cancellable={false}
				closeable={true}
				size={editorSize}
				eventPreview
			>
				{modalBody}
			</ModalComponent>
		</div>
	);
};

export default AgendaPreviewModal;